import {SET_KSES, SET_KSES_LOADING, RESET_KSES, SET_MORE_KSES} from './constants'

export const setKsesAction = (payload) => ({ type: SET_KSES, payload });
export const setMoreKsesAction = (payload) => ({ type: SET_MORE_KSES, payload });
export const setKsesLoadingAction = (payload) => ({ type: SET_KSES_LOADING, payload });
export const resetKsesAction = () => ({ type: RESET_KSES });